export default {
  header:{
    text1:'Home',
    text2:'About',
    text3:'Games',
  },
  banner:{
    text1:'Creating a better Game',
    text2:'We are creating a better gaming experience and to bring innovati together with a high level of quality to create a more enjoyable gaming experience.',
    text3:'Learn More',
    text4:'Welcome to s1',
    text5:'Our multi-award winning slots portfolio contains unique in-house content consisting of many games, available in many currencies.',
    text6:'Play now',
  },
    about:{
      txt1:'About Us',
      txt2:'This is our story',
      txt3:'We are S1 Gaming',
      txt4:'Our passion for gaming is limitless',
      txt5:'Here at S1 Gaming we thrive on innovation and have been pushing boundaries in the gaming industry for over a decade. Our aim is to deliver top-performing games with high-quality graphics, innovative mechanics, and strong player engagement. S1 Gaming values a diverse portfolio, offering games with global flavours across various themes and mechanics.',
      text6:'Incredibly features',
      text7:'Game product features',
      text8:'High-quality games',
      text9:'Designed internally with top-notch interactive art.',
      text10:'Fairness',
      text11:'Fair game mechanism and the stable numerical fluctuations.',
      text12:'Multi-Platform',
      text13:'Supporting most popular browsers and operation systems.',
      text14:'API Integration',
      text15:'Detailed technical documentation that provide partners with a smooth docking process.',
    },
      home:{
        text1:'Most complete',
        text2:'Game Collection',
        text3:'NEW',
        text4:'COMING SOON',
        text5:'View all games',
        text6:'',
      },
  message: {
    text1: 'Games',
    text2: 'Game product features',
    text4:` Lucky Gaming has experienced professionals in programming technology, art vision, numerical engineering and other professionals. It has continuously expanded its team to develop many unique gaming games, and is determined to become the most competitive game brand.`,
    text5:'High-quality games',
    text6:'Designed internally with top-notch interactive art.',
    text7:"Fairness",
    text8:"Fair game mechanism and the stable numerical fluctuations.",
    text9:"Multi-Platform",
    text10:"Supporting most popular browsers and operation systems.",
    text11:"API Integration",
    text12:"Detailed technical documentation that provide partners with a smooth docking process.",
    text13:"Home",
    text14:"Login",
    text15:"Account",
    text16:"Password",
    text17:"Featured Games",
    text18:"PLAY",
    text19: 'No Datas',
    text20: 'Coming Soon',
    text21: 'Lucky Gaming Original',
    text22: 'Welcome to the most amazing online casino category. ',
    text23: 'This is a collection created by the Lucky Gaming developers just for you!',
    text24: 'Loading...',
    text25: '',
    text26: '',

  },
  games:{
   text1: "Gems of Olympus",
   text2: "Golden Mahjong 2",
   text3: "Fire Ball Day of the Dead",
   text4: "Golden Miner",
   text5: "Safari World",
   text6: "Cleopatra’s Treasure",
   text7: "Egyptian Legends",
   text8: "Fire Ball Jurassic ",
   text9: "Hawaii Paradise",
   text10: "Speed King",
   text11: "Fire Ball Gahesha ",
   text12: "Gladiator",
  },
  seo: {
    logo: 'At S1 Gaming, we take pride in innovation and have been pushing boundaries in the gaming industry for over a decade. Our goal is to deliver exceptional performing games with high-quality graphic design, innovative game mechanics, and strong player interactivity. S1 Gaming values a diverse game portfolio, offering global game choices with various themes and mechanisms.',
    game1: 'The unique design of Gems of Olympus exudes a magnificent luster, incorporating elements of ancient Greek mythology.',
    game2: 'The combination of golden dragons and mahjong tiles represents luck and fortune in Chinese traditional culture.',
    game3: 'The blazing fireball of Day of the Dead intertwines with the shadows of Halloween night, creating a strong festive atmosphere.',
    game4: 'Surrounded by glittering gold ores, symbolizing the hardships of gold mining and abundant rewards.',
    game5: 'The spectacular landscape of the African continent, featuring grasslands, wildlife, and sunset, creates a serene yet magnificent natural atmosphere.',
    game6: "The exquisite jewelry and ancient relics of Cleopatra's Treasure represent the luxury and mystery of ancient Egypt.",
    game7: 'The deities and ancient symbols in Egyptian Legends showcase the power and mysterious world of ancient Egyptian mythology.',
    game8: 'A blazing fireball flies through the Jurassic sky, with a backdrop of dinosaur herds and ancient forests, filled with prehistoric mystery.',
    game9: 'The Hawaiian paradise-like beach, with turquoise waters and white sand, swaying palm trees in the distance, presents a tranquil tropical paradise scene.',
    game10: "The Speed King's race car speeds on the track, leaving scorching tire marks, demonstrating unparalleled speed and power.",
    game11: 'In the dazzling flames of the fireball, the massive image of the elephant god of wealth stands in the center, symbolizing fortune and prosperity.',
    game12: 'Gladiators wield swords and shields in the arena, surrounded by the historical atmosphere of the ancient Roman Colosseum, full of strength and dueling spirit.',
  },
  notFound: {
    text1: 'Sorry! The page you are looking for does not exist. Please reload.',
    text2: 'Back to Home'
  },
  meta: {
    title: 'S1 Gaming',
    description: 'Play free demo slot games online! Discover innovative slot machines with stable performance, high compatibility, and no download required. Try now!',
    h1: 'Free Demo Slot Experience | S1 Gaming Platform',
    about: {
      title: 'About S1 Gaming',
      description: 'Our Story, Our Games, Our Vision',
      h1: 'The Story and Passion Behind S1 Gaming’s Game Innovation'
    },
    games: {
      title: 'Play Now',
      description: 'Play free demo slot machine games with S1 Gaming. Enjoy high-quality, professional electronic slot reels anytime—no download, no signup required!',
      h1: 'Enjoy free slot machine games with no download or signup. Instant play available on all S1 Gaming demo slot games – fun and easy to start!'
    }
  }
}
